import { render, staticRenderFns } from "./ExhibitorDetails.vue?vue&type=template&id=8d89cf4e"
import script from "./ExhibitorDetails.vue?vue&type=script&lang=js"
export * from "./ExhibitorDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports